var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"advantage_wrap"},_vm._l((_vm.advantageList),function(item,index){return _c('el-col',{key:index,staticClass:"advantage_item",attrs:{"span":5,"xs":11}},[_c('img',{staticClass:"responsive-img",attrs:{"src":item.img,"alt":"Image"}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }